@for (service of services; track service) {
  <systembar-service-tab-item [service]="service"></systembar-service-tab-item>
}
